// Axios
import axios from "../../../lib/axios"

// --------------------------------------------|| PAYMENT - SERVICES || -------------------------------------------

const getInquiryInstallmentPayment = (facilityRequestId: number) => {
  return axios.get("/api/v1/payment/inquiryInstallmentPayment", { params: { facilityRequestId } })
}

const getinquiryInstallmentPaymentWithoutLogin = (params) => {
  return axios.get("/api/v1/payment/inquiryInstallmentPaymentWithoutLogin", {
    params: {
      ContractNumber: params.paymentCode
    }
  })
}

const installmentPaymentPin = data => {
  return axios.post("/api/v1/payment/installmentPaymentPin", data)
}
const installmentPaymentPinWithoutLogin = data => {
  return axios.post("/api/v1/payment/installmentPaymentPinWithoutLogin", data)
}

const installmentPayment = data => {
  return axios.post("/api/v1/payment/installmentPayment", data)
}

const installmentPaymentWithoutLogin = data => {
  return axios.post("/api/v1/payment/installmentPaymentWithoutLogin", data)
}

const paymentInstallmentsServices = { getInquiryInstallmentPayment, installmentPaymentPin, installmentPaymentPinWithoutLogin, installmentPayment, installmentPaymentWithoutLogin, getinquiryInstallmentPaymentWithoutLogin }

export default paymentInstallmentsServices
